import { useQuery } from "@tanstack/react-query";
import { getWorkspaces } from "../../../api/Terminal/Workspace";
import { ReactQueryKey } from "../../../constants/ReactQueryKeys";
import { QueryParamsInterface } from "types/Shared";

interface IWorkspacesHookProps {
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  params?: QueryParamsInterface;
}

export const useWorkspaces = ({
  onSuccess,
  onError,
  params,
}: IWorkspacesHookProps) => {
  return useQuery([ReactQueryKey.GET_WORKSPACES, params], () => getWorkspaces(params), {
    onSuccess,
    onError,
    select: (data: IGetWorkspacesServiceRes) => [
      {
        name: "All Program",
        description: "All Program on your organization account",
      },
      ...data.data,
    ],
  });
};
